import moment from 'moment';
import { useState } from 'react';
import { TableInput } from '../../../../../components/common';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../components/common/formatDate';
import { TableCompHead } from '../../../../../components/ui';
import { IModule } from '../../interface';

interface IProps {
  isView: boolean;
  moduleData: IModule;
}
const THead = ({ moduleData, isView }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <thead>
      <TableCompHead
        colSpan={9}
        rowSpan={3}
        labels={['Doc No:', 'REV. NO.:', 'REV. DATE:']}
        values={['FM-QAD-01', '05', ' 03/10/2023']}
        heading="INSPECTION STANDARDS PARTS"
      />
      <tr>
        <th colSpan={9} align="left">
          Date:
          {isView ? (
            formatDate(moduleData.moduleDate)
          ) : (
            <DatePickerMui
              value={moment(moduleData.moduleDate)}
              onChange={(date) => {
                moduleData.moduleDate = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          TISP- No.
        </th>
        <th colSpan={2} align="left">
          <TableInput
            name="tisp_no"
            type="text"
            value={moduleData.tisp_no}
            onChange={(e) => {
              moduleData.tisp_no = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={2} align="left">
          Part Name
        </th>
        <th colSpan={3} align="left">
          {moduleData?.ri_part_id?.part_name_2 || moduleData.partName2 || ''}
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          Supplier Part No.
        </th>
        <th colSpan={2} align="left">
          {moduleData?.ri_part_id?.part_number || moduleData.partNumber || ''}
        </th>
        <th colSpan={2} align="left">
          Customer Part No.
        </th>
        <th colSpan={3} align="left">
          <TableInput
            name="customer_part_no"
            type="text"
            value={moduleData.customer_part_no}
            onChange={(e) => {
              moduleData.customer_part_no = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          Material
        </th>
        <th colSpan={2} align="left">
          {moduleData?.ri_part_id?.part_name || moduleData.partName || ''}
        </th>
        <th colSpan={2} align="left">
          Drawing Rev./ Date
        </th>
        <th colSpan={1} align="left">
          <TableInput
            name="drawing_rev"
            type="text"
            value={moduleData.drawing_rev}
            onChange={(e) => {
              moduleData.drawing_rev = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={2} align="left">
          {isView ? (
            formatDate(moduleData.drawing_date)
          ) : (
            <DatePickerMui
              value={moment(moduleData.drawing_date) || null}
              onChange={(date) => {
                moduleData.drawing_date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
      </tr>
      <tr>
        {[
          'S. NO.',
          'DISCRIPTION',
          'SPECIFICATION',
          'INSPECTION METHOD',
          'SAMPLE SIZE/FREQ.',
          'CONTROL',
          'RESP.',
          'REACTION PLAN',
          'Action',
        ].map((heading) => (
          <th key={heading} style={{ textTransform: 'uppercase' }}>
            {heading}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
